var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnassignedType(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.3198 1.99961C7.4398 1.75961 7.71981 1.59961 7.9998 1.59961C8.27981 1.59961 8.5598 1.75961 8.6798 1.99961L15.0798 13.1996C15.2398 13.4396 15.2398 13.7596 15.0798 13.9996C14.9598 14.2396 14.6798 14.3996 14.3998 14.3996H1.5998C1.3198 14.3996 1.0798 14.2396 0.919805 13.9996C0.759805 13.7596 0.759805 13.4396 0.919805 13.1996L7.3198 1.99961ZM14.3998 13.5996L7.9998 2.39961L1.5998 13.5996H14.3998ZM8.3598 10.3996C8.43981 9.43961 8.6398 6.75961 8.6398 5.99961V5.59961H7.4398V5.99961C7.4398 6.75961 7.5998 9.43961 7.7198 10.3996H8.3598ZM7.9998 12.7996C8.44163 12.7996 8.7998 12.4414 8.7998 11.9996C8.7998 11.5578 8.44163 11.1996 7.9998 11.1996C7.55798 11.1996 7.1998 11.5578 7.1998 11.9996C7.1998 12.4414 7.55798 12.7996 7.9998 12.7996Z",
    fill: "#D62D0A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnassignedType);
export default __webpack_public_path__ + "static/media/unassigned-type.16cd156a361af12b9f9e5c4bdfc0278f.svg";
export { ForwardRef as ReactComponent };